import { render, staticRenderFns } from "./ScreenTmpl.vue?vue&type=template&id=77697b24&scoped=true&"
import script from "./ScreenTmpl.vue?vue&type=script&lang=js&"
export * from "./ScreenTmpl.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTmpl.vue?vue&type=style&index=0&id=77697b24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77697b24",
  null
  
)

export default component.exports